import { init } from "@plausible-analytics/tracker"

let plausibleInitialised = false

function initPlausible({ role }: { role: string }) {
  if (!import.meta.env.VITE_APP_PLAUSIBLE_DOMAIN) return
  if (plausibleInitialised) return
  plausibleInitialised = true
  init({
    domain: import.meta.env.VITE_APP_PLAUSIBLE_DOMAIN,
    captureOnLocalhost: import.meta.env.VITE_APP_ENV === "local",
    customProperties: { role },
  })
}

export default initPlausible
